import React, { useEffect, useState } from "react";
import db from "./Firebase";// adjust path to your firebase config

const EightyEight = () => {
  const [subs, setSubs] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const snapshot = await db
          .collection("subscriptions_data")
          .where("price", "==", 88) // only price 88
          .get();

        const data = snapshot.docs.map(doc => ({
          id: doc.id,
          ...doc.data()
        }));
        setSubs(data);
      } catch (err) {
        console.error("Error fetching data: ", err);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  if (loading) return <div>Loading...</div>;

  return (
    <div>
      <h3>Subscriptions with Price 88</h3>
      {subs.length === 0 && <p>No records found.</p>}
      <ul>
        {subs.map((sub) => (
          <li key={sub.id}>
            <strong>{sub.customer_name}</strong> ({sub.customer_phone}) — 
            {sub.product_name} – {sub.package_unit} @ ₹{sub.price}
            <br/>
            Next delivery: {sub.next_delivery_date}
          </li>
        ))}
      </ul>
    </div>
  );
};

export default EightyEight;
